import { createClient } from '@/shared/api';
import type {
  SendConsultingRequestMutation,
  SendConsultingRequestMutationVariables,
} from '@/shared/api';
import SEND_CONSULTING_REQUEST from '../mutations/sendConsultingRequest';

/**
 * Submits a clinic consulting request. Runs the SEND_CONSULTING_REQUEST mutation and throws the returned message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleSendConsultingRequest = async (
  input: SendConsultingRequestMutationVariables['input'],
): Promise<void> => {
  const client = createClient();
  const result = await client.mutate<
    SendConsultingRequestMutation,
    SendConsultingRequestMutationVariables
  >({
    mutation: SEND_CONSULTING_REQUEST,
    variables: {
      input,
    },
  });
  const { isSuccess, message } = result.data?.sendConsultingRequest || {};
  if (!isSuccess) {
    throw new Error(message ?? undefined);
  }
};

export default handleSendConsultingRequest;
